module.exports = __webpack_public_path__ + "static/firepit-6680ab551bebe084a19d4280f027232d.png";